export default (id, items = []) =>
    items.filter((item) => {
        if (item.id === id) {
            return item;
        }
        return false;
    })[0];
